import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      <div className="header__menu">
        <Link to="/" className="header__logo" aria-label="Main Page" onClick={closeMenu}>
          <h1 className="header__title">Villa Mandragora</h1>
        </Link>

        <button
          className={`burger-button ${isMenuOpen ? 'open' : ''}`}
          type="button"
          aria-label="Open menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="burger-icon"></span>
        </button>
      </div>

        <nav className={`header-links ${isMenuOpen ? 'header-links_open' : ''}`}>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
            onClick={closeMenu}
          >
            Home
          </NavLink>

          <NavLink
            to="/location"
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
            onClick={closeMenu}
          >
            location
          </NavLink>

          <NavLink
            to="/gallery"
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
            onClick={closeMenu}
          >
            Gallery
          </NavLink>

          <NavLink
            to="/reservation"
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
            onClick={closeMenu}
          >
            Reserve
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
            onClick={closeMenu}
          >
            Contact us
          </NavLink>
        </nav>
    </header>
  );
}

export default Header;
